export const loaded = new Promise((resolve) => {
  if (window.monaco) {
    resolve(window.monaco);
    return;
  }

  window.addEventListener('monaco:ready', () => resolve(window.monaco), { once: true });
});

export const installWorkers = (urls) => {
  self.MonacoEnvironment = {
    getWorker: (_moduleId, label) => new Worker(urls[label] ?? urls.editorWorkerService, { type: 'module' }),
  };
};

export const themeName = () => {
  const stored = document.documentElement.getAttribute('data-theme');
  const dark = stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;

  return dark ? 'flow-dark' : 'flow-light';
};

export const watchTheme = (monaco) => {
  const observer = new MutationObserver(() => monaco.editor.setTheme(themeName()));

  observer.observe(document.documentElement, { attributeFilter: ['data-theme'] });

  return observer;
};
